import './App.css';
import Home from './pages/Home';
import ShoreOpportunities from './pages/ShoreOpportunities';
import SeaOpportunities from './pages/SeaOpportunities';
import {BrowserRouter, Route, Routes } from 'react-router-dom';
function App() {
  return (
    <BrowserRouter basename='/work_with_us'>
      <Routes>
          <Route index element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;